// import { useEffect } from "react"
// import { Outlet, useLocation } from "react-router-dom"
// import { useDispatch } from "react-redux"
// import { HelmetProvider } from "react-helmet-async" // Add this import
// import Header from "../src/comp/Component/Header"
// import Footer from "../src/Component/Home/Footer"
// import { Toaster } from "react-hot-toast"

// import fetchUserDetails from "./comp/Utils/fetchUserDetail"
// import { setAllCategory } from "./comp/Store/ProductSlice"
// import { setUserDetails } from "./comp/Store/Userslice"
// import Axios from "./comp/Utils/axios"
// import SummaryAPI from "./comp/Commson/summaryApi"

// import "./App.css" 

// const App = () => {
//   const dispatch = useDispatch()
//   const location = useLocation()

//   const fetchUser = async () => {
//     const userData = await fetchUserDetails()
//     if (userData) dispatch(setUserDetails(userData))
//   }

//   const fetchCategory = async () => {
//     try {
//       const response = await Axios({ ...SummaryAPI.getAllCategories })
//       if (response?.data?.success) {
//         dispatch(setAllCategory(response.data.data))
//       }
//     } catch (error) {
//       console.error("Category fetch error", error)
//     }
//   }

//   // Initial load
//   useEffect(() => {
//     fetchUser()
//     fetchCategory()
//   }, [])

//   // Meta Pixel page view on route change
//   useEffect(() => {
//     if (window.fbq) {
//       window.fbq("track", "PageView")
//     }
//   }, [location.pathname])

//   return (
//     <HelmetProvider> {/* Wrap everything with HelmetProvider */}
//       <div className="min-h-screen flex flex-col bg-white overflow-x-hidden">
        
//         {/* Header */}
//         <header className="sticky top-0 z-50 w-full bg-white shadow-sm">
//           <Header />
//         </header>

//         {/* Main Content */}
//         <main className="flex-1 w-full">
//           <Outlet />
//         </main>

//         {/* Footer */}
//         <footer className="w-full bg-gray-50 border-t border-gray-200">
//           <Footer />
//         </footer>

//         {/* Toast */}
//         <Toaster
//           position="top-right"
//           toastOptions={{
//             className: "text-sm",
//           }}
//         />
//       </div>
//     </HelmetProvider>
//   )
// }

// export default App


import { useEffect, useState } from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { HelmetProvider } from "react-helmet-async"
import Header from "../src/comp/Component/Header"
import Footer from "../src/Component/Home/Footer"
import { Toaster } from "react-hot-toast"
import VideoModal from "../src/Component/Home/VideoPage"

import fetchUserDetails from "./comp/Utils/fetchUserDetail"
import { setAllCategory } from "./comp/Store/ProductSlice"
import { setUserDetails } from "./comp/Store/Userslice"
import Axios from "./comp/Utils/axios"
import SummaryAPI from "./comp/Commson/summaryApi"

import "./App.css"

// Collection data for direct URL access
const collectionsData = {
  "laminance-cabinetry-video-1": { 
    id: "laminance-cabinetry-video-1", 
    video: "/assets/laminancekitchen.mp4", 
    thumbnail: "/assets/newkit.jpeg", 
    title: "Modern Acrylic Kitchen Collection - Laminance Cabinetry",
    description: "Luxury acrylic kitchen cabinets with premium high-gloss finish. Modern European design by Laminance Cabinetry."
  },
  "laminance-cabinetry-video-2": { 
    id: "laminance-cabinetry-video-2", 
    video: "/assets/vide1.mp4", 
    thumbnail: "/assets/Image-73.jpg", 
    title: "Matte Luxury Kitchen Collection - Laminance Cabinetry",
    description: "Sophisticated matte finish cabinets with anti-fingerprint technology by Laminance Cabinetry."
  },
  "laminance-cabinetry-video-3": { 
    id: "laminance-cabinetry-video-3", 
    video: "/assets/vid2.mp4", 
    thumbnail: "/assets/Image-883.jpg", 
    title: "Contemporary Glass Kitchen Collection - Laminance Cabinetry",
    description: "Stunning glass-front cabinets with interior lighting options. Contemporary design by Laminance Cabinetry."
  },
  "laminance-cabinetry-video-4": { 
    id: "laminance-cabinetry-video-4", 
    video: "/assets/vid3.mp4", 
    thumbnail: "/assets/Image-121.jpg", 
    title: "European Style Kitchen Collection - Laminance Cabinetry",
    description: "Sleek European-style cabinets with minimalist design. Premium craftsmanship by Laminance Cabinetry."
  },
  "laminance-cabinetry-video-5": { 
    id: "laminance-cabinetry-video-5", 
    video: "/assets/vid4.mp4", 
    thumbnail: "/assets/Image-912.jpg", 
    title: "Traditional Wood Kitchen Collection - Laminance Cabinetry",
    description: "Warm traditional wood cabinets from premium solid hardwoods. Timeless elegance by Laminance Cabinetry."
  },
  "laminance-cabinetry-video-6": { 
    id: "laminance-cabinetry-video-6", 
    video: "/assets/vid5.mp4", 
    thumbnail: "/assets/videoframe_0.png", 
    title: "Luxury Modular Kitchen Collection - Laminance Cabinetry",
    description: "Flexible modular kitchen system with smart storage solutions. Custom designs by Laminance Cabinetry."
  },
  "laminance-cabinetry-video-7": { 
    id: "laminance-cabinetry-video-7", 
    video: "/assets/vid6.mp4", 
    thumbnail: "/assets/629992239_17898564786381730_7476464499665088684_n.jpg", 
    title: "Urban Contemporary Kitchen Collection - Laminance Cabinetry",
    description: "Bold contemporary designs for modern urban living. Innovative solutions by Laminance Cabinetry."
  },
  "laminance-cabinetry-video-8": { 
    id: "laminance-cabinetry-video-8", 
    video: "/assets/vid1.mp4", 
    thumbnail: "/assets/thms8.png", 
    title: "Signature Collection - Laminance Cabinetry",
    description: "Premium signature collection with custom finishes. Exclusive designs by Laminance Cabinetry."
  },
};

const App = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  
  const [currentVideo, setCurrentVideo] = useState(null)

  const fetchUser = async () => {
    const userData = await fetchUserDetails()
    if (userData) dispatch(setUserDetails(userData))
  }

  const fetchCategory = async () => {
    try {
      const response = await Axios({ ...SummaryAPI.getAllCategories })
      if (response?.data?.success) {
        dispatch(setAllCategory(response.data.data))
      }
    } catch (error) {
      console.error("Category fetch error", error)
    }
  }

  useEffect(() => {
    fetchUser()
    fetchCategory()
  }, [])

  useEffect(() => {
    if (window.fbq) {
      window.fbq("track", "PageView")
    }
  }, [location.pathname])

  // Function to open video modal with SEO-friendly URL
  const openVideoModal = (collection) => {
    setCurrentVideo(collection)
    window.history.pushState({ videoId: collection.id }, '', `/video/${collection.id}`)
  }

  // Function to close video modal and restore URL
  const closeVideoModal = () => {
    setCurrentVideo(null)
    window.history.pushState({}, '', '/')
  }

  // Handle browser back button
  useEffect(() => {
    const handlePopState = () => {
      if (currentVideo) {
        closeVideoModal()
      }
    }
    window.addEventListener('popstate', handlePopState)
    return () => window.removeEventListener('popstate', handlePopState)
  }, [currentVideo])

  // Check URL on initial load to open video directly from shared link
  useEffect(() => {
    const path = window.location.pathname
    if (path.startsWith('/video/')) {
      const videoId = path.replace('/video/', '')
      const collection = collectionsData[videoId]
      if (collection) {
        setTimeout(() => {
          setCurrentVideo(collection)
        }, 500)
      }
    }
  }, [])

  return (
    <HelmetProvider>
      <div className="min-h-screen flex flex-col bg-white overflow-x-hidden">
        
        {/* Header */}
        <header className="sticky top-0 z-40 w-full bg-white shadow-sm">
          <Header />
        </header>

        {/* Main Content */}
        <main className="flex-1 w-full">
          <Outlet context={{ openVideoModal }} />
        </main>

        {/* Footer */}
        <footer className="w-full bg-gray-50 border-t border-gray-200">
          <Footer />
        </footer>

        {/* Toast */}
        <Toaster
          position="top-right"
          toastOptions={{
            className: "text-sm",
          }}
        />

        {/* Video Modal */}
        {currentVideo && (
          <VideoModal video={currentVideo} onClose={closeVideoModal} />
        )}
      </div>
    </HelmetProvider>
  )
}

export default App